import { findConversation } from './findConversation';
import getFindConversationTraversal from './utils/getFindConversationTraversal';
import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import FindConversationResponseMessage from 'owa-service/lib/contract/FindConversationResponseMessage';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import SortResults from 'owa-service/lib/contract/SortResults';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import constant from 'owa-service/lib/factory/constant';
import fieldURIOrConstantType from 'owa-service/lib/factory/fieldURIOrConstantType';
import isEqualTo from 'owa-service/lib/factory/isEqualTo';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import restrictionType from 'owa-service/lib/factory/restrictionType';
import seekToConditionPageView from 'owa-service/lib/factory/seekToConditionPageView';
import RequestOptions from 'owa-service/lib/RequestOptions';

/**
 * The findConversationWithSeekToInstanceKeyCondition is based on the instance key of the last row present locally in the table.
 * This is currently used for load more scenario
 * @param folderId - The folderId for which we are fetching the data
 * @param instanceKey - We use instancekey of the last conversation we have in the loaded rows in the table
 * @param rowsToLoad - the number of rows to load
 * @param viewFilter - view filter (e.g - Unread\Flag)
 * @param sortResults - sort by properties
 * @param focusedViewFilter the focused view filter
 * @param findConversationShapeName - the shape for the request
 * @param options - optional parameters to be passed to request (method and/or headers)
 * @param categoryName - the cateogry name
 * @param hashtagsToInclude the hashtags to include for the request
 * @param hashtagsToExclude the hashtags to exclude for the request
 */
export function findConversationWithSeekToInstanceKeyCondition(
    folderId: BaseFolderId,
    instanceKey: string,
    rowsToLoad: number,
    viewFilter: ViewFilter,
    sortResults: SortResults[],
    focusedViewFilter: FocusedViewFilter,
    findConversationShapeName: string,
    options: RequestOptions,
    categoryName: string,
    hashtagsToInclude?: string[],
    hashtagsToExclude?: string[],
    searchFolderId?: BaseFolderId
): Promise<FindConversationResponseMessage> {
    const restriction = isEqualTo({
        FieldURIOrConstant: fieldURIOrConstantType({
            Item: constant({
                Value: instanceKey,
            }),
        }),
        Item: propertyUri({
            FieldURI: 'ConversationInstanceKey',
        }),
    });

    const seekToCondition = restrictionType({
        Item: restriction,
    });

    const paging = seekToConditionPageView({
        BasePoint: 'Beginning',
        Condition: seekToCondition,
        MaxEntriesReturned: rowsToLoad,
    });

    return findConversation(
        folderId,
        paging,
        viewFilter,
        sortResults,
        focusedViewFilter,
        findConversationShapeName,
        options,
        categoryName,
        getFindConversationTraversal(viewFilter),
        hashtagsToInclude,
        hashtagsToExclude,
        searchFolderId
    ).then((response: Response) => {
        return response.json().then(json => json.Body);
    });
}
